import React from 'react';
import { dummyCallback } from '../../utils/complexDocumentConstants';
import VariableForm from '../ComplexDocumentDesign/complexVariables/VariableForm';
import { Icon } from 'antd';
import styled from 'styled-components';
import { ListContainer } from '../ComplexDocumentDesign/complexVariables/styles';
import { EmptyListImage } from '../../artboard/VariablesList/styles';
import EmptyList from '../../images/empty-list.svg';
import { COMMUNICATION_GENERATOR } from './translationValues';
import { useTranslation } from 'react-i18next';

const NAMESPACE = ['COMMUNICATION_GENERATION'];

const VariablesContainer = styled.div`
  width: 100%;
  > div > div {
    width: 100%;
  }
  > div > div > div {
    display: block;
    .variable-type {
      display: none;
      & + p {
        color: black;
      }
    }

    .ant-input {
      color: rgba(0, 0, 0, 0.65) !important;
      background: #fff !important;
    }
    .ant-btn-link {
      color: #000000;
      > i {
        color: inherit;
      }
      > span {
        color: inherit;
      }
    }
    .ant-calendar-picker {
      .ant-calendar-picker-icon {
        color: #000000;
      }
    }
    .ant-table-wrapper {
      margin-top: 0px !important;
      thead {
        tr {
          th {
            background: #fafafa;
            color: rgba(0, 0, 0, 0.85);
          }
        }
      }
      tbody {
        tr {
          td {
            background-color: #fff !important;
            color: rgba(0, 0, 0, 0.85) !important;
            .ant-input {
              color: rgba(0, 0, 0, 0.65) !important;
              background: #fff !important;
            }
          }
        }
      }
    }
    a {
      color: #000000;
    }
    .ant-collapse {
      .ant-collapse-item {
        background-color: #e9e9e9 !important;
        margin-bottom: 0px !important;
        .ant-collapse-header {
          color: #000000 !important;
        }
        .ant-collapse-content {
          .block {
            row-gap: 15px;
            padding-bottom: 0px;
            padding-top: 0px;
            .varName {
              margin-bottom: 10px;
              p {
                color: #000000;
                text-transform: none;
              }
              & + div {
                width: 100% !important;
              }
            }
            > div {
              display: block;
            }
          }
        }
      }
    }
    [id^='tool-'] {
      width: 100%;
      > div {
        width: 100%;
      }
      & > div > {
        .ant-collapse {
          > .ant-collapse-item {
            margin-bottom: 10px !important;
            > .ant-collapse-content > .ant-collapse-content-box > .block {
              padding-bottom: 20px;
            }
          }
        }
      }
    }
    .ql-toolbar.ql-snow {
      background: rgba(0, 0, 0, 0.8);
    }
    .ql-container.ql-snow {
      .ql-editor {
        & > p {
          color: #000000;
        }
      }
    }
  }
`;

const FormCard = styled.div`
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  padding: 40px;
  animation: slideInFromRight 0.4s cubic-bezier(0.4, 0, 0.2, 1);

  @keyframes slideInFromRight {
    from {
      opacity: 0;
      transform: translateX(30px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @media (max-width: 768px) {
    padding: 24px;
  }
`;

const FormHeader = styled.div`
  margin-bottom: 32px;
  padding-bottom: 20px;
  border-bottom: 2px solid #f0f0f0;
`;

const FormTitle = styled.h2`
  color: #333;
  margin: 0 0 8px 0;
  font-size: 24px;
`;

const FormSubtitle = styled.p`
  color: #666;
  margin: 0;
  font-size: 14px;
`;

const InfoBadges = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 16px;
  flex-wrap: wrap;
`;

const InfoBadgeModern = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 10px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25);
  flex: 1;
  min-width: 180px;
`;

const BadgeIcon = styled.div`
  font-size: 24px;
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #ffffff;
`;

const BadgeContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const BadgeLabel = styled.span`
  font-size: 11px;
  color: rgba(255, 255, 255, 0.8);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
`;

const BadgeValue = styled.span`
  font-size: 15px;
  color: #ffffff;
  font-weight: 600;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 32px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const BackButton = styled.button`
  height: 48px;
  border-radius: 8px;
  font-weight: 600;
  border: 2px solid #667eea;
  color: #667eea;
  background: white;
  padding: 0 24px;
  cursor: pointer;
  transition: all 0.3s;
  font-family: inherit;

  &:hover {
    background: #f5f7ff;
    border-color: #667eea;
    color: #667eea;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const SubmitButton = styled.button`
  flex: 1;
  height: 48px;
  background: #ffeb3b;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #333;
  box-shadow: 0 4px 12px rgba(255, 235, 59, 0.4);
  cursor: pointer;
  transition: all 0.3s;
  font-family: inherit;

  &:hover:not(:disabled) {
    background: #fdd835;
    color: #333;
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(255, 235, 59, 0.5);
  }

  &:disabled {
    background: #e0e0e0;
    color: #999;
    box-shadow: none;
    cursor: not-allowed;
  }

  &:focus {
    background: #ffeb3b;
    color: #333;
  }
`;

const EmptyForm = styled.div`
  display: flex;
  height: 40vh;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export function DynamicForm({
  showDownloadLoader,
  communicationDetails,
  channel,
  language,
  formVariables,
  examplValuesData,
  setExamplValuesData,
  documentVariables,
  errorMessages,
  setErrorMessages,
  onBack,
  onSubmit,
}) {
  const { t } = useTranslation(NAMESPACE);
  const updateExamplesValue = value => {
    setExamplValuesData(value);
    setErrorMessages({});
  };

  return (
    <FormCard>
      <FormHeader>
        <FormTitle>{communicationDetails.communicationName}</FormTitle>
        <FormSubtitle>
          {t(
            COMMUNICATION_GENERATOR.FILL_REQUIRED_FIELDS_MESSAGE.key,
            COMMUNICATION_GENERATOR.FILL_REQUIRED_FIELDS_MESSAGE.value,
          )}
        </FormSubtitle>
        <InfoBadges>
          <InfoBadgeModern>
            <BadgeIcon>
              {channel === 'email' ? <Icon type="mail" /> : <Icon type="printer" />}
            </BadgeIcon>
            <BadgeContent>
              <BadgeLabel>
                {t(
                  COMMUNICATION_GENERATOR.CHANNEL_LABEL.key,
                  COMMUNICATION_GENERATOR.CHANNEL_LABEL.value,
                )}
              </BadgeLabel>
              <BadgeValue>{channel === 'email' ? 'Email' : 'Print'}</BadgeValue>
            </BadgeContent>
          </InfoBadgeModern>
          <InfoBadgeModern>
            <BadgeIcon>
              <Icon type="global" />
            </BadgeIcon>
            <BadgeContent>
              <BadgeLabel>
                {t(
                  COMMUNICATION_GENERATOR.LANGUAGE_LABEL.key,
                  COMMUNICATION_GENERATOR.LANGUAGE_LABEL.value,
                )}
              </BadgeLabel>
              <BadgeValue>{language}</BadgeValue>
            </BadgeContent>
          </InfoBadgeModern>
        </InfoBadges>
      </FormHeader>

      <div>
        {formVariables?.length > 0 ? (
          <VariablesContainer>
            <ListContainer>
              <VariableForm
                documentVariables={documentVariables}
                examplValuesData={examplValuesData}
                setExamplValuesData={updateExamplesValue}
                errorMessages={errorMessages}
                isHtmlExpanded={false}
                setIsHtmlExpanded={dummyCallback}
                isInteractiveDesign={false}
                isGenerateFormPage={true}
              />
            </ListContainer>
          </VariablesContainer>
        ) : (
          <EmptyForm style={{}}>
            <EmptyListImage>
              <img src={EmptyList} alt="empty-list" />
            </EmptyListImage>
            {t(
              COMMUNICATION_GENERATOR.NO_VARIABLES_MESSAGE.key,
              COMMUNICATION_GENERATOR.NO_VARIABLES_MESSAGE.value,
            )}
          </EmptyForm>
        )}
      </div>

      <ButtonGroup>
        <BackButton onClick={onBack}>
          ← {t(COMMUNICATION_GENERATOR.BACK_BUTTON.key, COMMUNICATION_GENERATOR.BACK_BUTTON.value)}
        </BackButton>
        <SubmitButton onClick={onSubmit}>
          {showDownloadLoader && <Icon type="loading" />}{' '}
          {channel === 'print'
            ? t(
                COMMUNICATION_GENERATOR.GENERATE_DOCUMENT_BUTTON.key,
                COMMUNICATION_GENERATOR.GENERATE_DOCUMENT_BUTTON.value,
              )
            : t(
                COMMUNICATION_GENERATOR.SEND_EMAIL_BUTTON.key,
                COMMUNICATION_GENERATOR.SEND_EMAIL_BUTTON.value,
              )}
        </SubmitButton>
      </ButtonGroup>
    </FormCard>
  );
}
